import { useField, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import { DatePicker } from '@mui/x-date-pickers';
import { Moment } from 'moment';

const useStyles = makeStyles()(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  }
}));

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  className?: string;
  isValidDate?: (day: Moment) => boolean;
  helperText?: React.ReactNode;
};

const DateField = (props: Props) => {
  const {
    name,
    label,
    className,
    disabled,
    touched: formTouched,
    helperText,
    isValidDate,
  } = props;
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <DatePicker
      value={field.value}
      label={label}
      format="M/D/YYYY"
      disabled={disabled}
      shouldDisableDate={isValidDate ? (day: Moment) => !isValidDate(day) : undefined}
      onChange={(date) => {
        setFieldValue(name, date, true);
        setFieldTouched(name, true);
      }}
      onClose={() => {
        setFieldTouched(name, true);
      }}
      className={cx(classes.field, className)}
      slotProps={{
        textField: {
          name,
          onBlur: field.onBlur,
          variant: 'outlined',
          error: touched && Boolean(currentError),
          helperText: (touched && currentError) || helperText,
        },
      }}
    />
  );
};

export default DateField;
